
























































import { Vue, Component } from "vue-property-decorator";
import { CourseListParams } from "@/getinfo-api/course";
import { getCurrentUserId } from "@/plugins/roles";
import HomePageListenerCourseProgressItem from "@/components/home-page/HomePageListenerCourseProgressItem.vue";
import { CourseProgress as ICourseProgress } from "@/api/models/course-progress";
import { Course as ICourse } from "@/api/models/course";
import { CourseListener as ICourseListener } from "@/api/models/course-listener";
import { Webinar as IWebinar } from "@/api/models/webinar";
import WebinarListItem from "@/components/webinars/WebinarListItem.vue";
import { WebinarsListParams } from "@/getinfo-api/webinars";
import { VuexVideoListParams as IVuexVideoListParams } from "@/plugins/custom-interface";
import { Video as IVideo } from "@/api/models/video";
import RecordListItem from "@/components/records/RecordListItem.vue";
import { VuexVideoListParamsTypeEnum } from "@/plugins/custom-interface";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CourseV2ListenerProgress from "@/components/courses/CourseV2/CourseV2ListenerProgress.vue";
import courseRegistrations, {
  CourseRegistrationsListParams
} from "@/getinfo-api/courseRegistrations";
import { AxiosError } from "axios";
import {
  ErrorResponse as IErrorResponse,
  ValidationErrorResponse as IValidationErrorResponse
} from "@/api/models";
import { Registration as IRegistration } from "@/api-v2/course/models";
import { uniqBy } from "lodash";

@Component({
  components: {
    CourseV2ListenerProgress,
    CBlock,
    HomePageListenerCourseProgressItem,
    WebinarListItem,
    RecordListItem
  }
})
export default class HomePageListener extends Vue {
  limit: number = 30;
  isCourseGetProcessing: boolean = false;
  registrations: Array<IRegistration> = [];

  get userId(): string {
    return getCurrentUserId();
  }

  get courseListeners(): Array<ICourseListener> {
    return this.$store.getters["homepage/listenerPage/LISTENER_IN_COURSES"];
  }

  get courses(): Array<ICourse> {
    const courses: ICourse[] = this.$store.getters[
      "homepage/listenerPage/COURSES"
    ];
    return uniqBy(courses, "id");
  }

  get coursesCount(): number {
    return this.$store.getters["homepage/listenerPage/COURSES_COUNT"];
  }

  get courseProgress(): Array<ICourseProgress> {
    const progress: Array<ICourseProgress> = this.$store.getters[
      "homepage/listenerPage/PROGRESSES"
    ];
    return uniqBy(progress, "id");
  }

  get coursesInProgressed(): Array<ICourseProgress> {
    return this.courseProgress.filter(el => !el.learningCompleted);
  }

  get accessTokenDev() {
    const token = localStorage.getItem("auth-tokens-development");
    return token ? JSON.parse(token) : null;
  }

  get accessTokenProd() {
    const token = localStorage.getItem("auth-tokens-production");
    return token ? JSON.parse(token) : null;
  }

  get webinars(): Array<IWebinar> {
    const _webinars: IWebinar[] = this.$store.getters[
      "webinars/LISTENER_WEBINARS"
    ];
    return uniqBy(_webinars, "id");
  }

  get records(): Array<IVideo> {
    const _records: IVideo[] = this.$store.getters["records/LISTENER_RECORDS"];
    return uniqBy(_records, "id");
  }

  async getWebinars() {
    const params: WebinarsListParams = {
      sort: "finishedAt",
      order: "ASC",
      viewerId: this.userId
    };
    await this.$store.dispatch("webinars/GET_WEBINARS", params);
  }

  async getRecords() {
    const params: IVuexVideoListParams = {
      type: VuexVideoListParamsTypeEnum.listener,
      viewerId: this.userId
    };
    await this.$store.dispatch("records/GET_RECORDS", params);
  }

  async getListenersInformation() {
    this.isCourseGetProcessing = true;
    let params: CourseListParams = {
      listenerUserIds: [this.userId],
      enabled: true,
      limit: this.limit,
      sort: "createdAt",
      order: "ASC"
    };

    await this.$store.dispatch("homepage/listenerPage/GET_COURSES", params);
    let arg = {
      courses: this.courses,
      userId: this.userId
    };
    await this.$store.dispatch(
      "homepage/listenerPage/COURSES_LISTENER_BY_USER_ID",
      arg
    );
    await this.$store.dispatch(
      "homepage/listenerPage/COURSES_PROGRESS",
      this.courseListeners
    );
    this.isCourseGetProcessing = false;
  }

  getCourseRegistration() {
    const params: CourseRegistrationsListParams = {
      studentUserIds: [this.userId],
      statuses: ["learning"]
    };
    courseRegistrations(params)
      .then(res => {
        this.registrations = res.data.items;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  created() {
    this.getWebinars();
    this.getListenersInformation();
    this.getRecords();
    this.getCourseRegistration();
  }

  beforeDestroy() {
    this.$store.commit("homepage/listenerPage/CLEAR");
    this.$store.commit("webinars/CLEAR");
    this.$store.commit("records/CLEAR");
  }
}
